import React from 'react'

const BrowserFrame = ({ imageUrl, alt = '', className = '' }) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="rounded-lg overflow-hidden shadow-xl border border-gray-300/60">
        {/* Browser header bar */}
        <div className="flex bg-gray-300/60 p-3 items-center">
          <div className="flex gap-2">
            <span className="size-3 rounded-full bg-[#ff5f56]"></span>
            <span className="size-3 rounded-full bg-[#ffbd2e]"></span>
            <span className="size-3 rounded-full bg-[#27c93f]"></span>
          </div>
        </div>
        {/* Browser content */}
        <div className="browser-content">
          <img
            className="block w-full"
            src={imageUrl}
            alt={alt}
          />
        </div>
      </div>
    </div>
  )
}

export default BrowserFrame